import React, { useState, useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { Alert, Button, Container, Col, Row } from "reactstrap"
import { useQuery } from "@tanstack/react-query"

import storage from "services/storage"
import { API, authUserKey } from "config/API"
import { getBusinessInfo } from "services/business-info"

const BusinessInfo = () => {
  document.title = "Información del Ticket | Punto de venta"

  const Location = useLocation()
  const history = useHistory()
  const [filters, setFilters] = useState("")
  const [image, setImage] = useState("")
  const businessInfo = useQuery(["businessInfo", filters, filters.toString()], () => getBusinessInfo(filters))
  const business = businessInfo?.data?.results[0]
  const apiUrl = ["https://api.pos.emkode.org", "https://api-dulceria.emkode.com", "https://api-plasticos.emkode.com"]

  const permissions = storage.get(authUserKey).user_permissions || []
  const canEdit = permissions.some((e) => e.codename === "change_businessinfo")

  useEffect(() => {
    setFilters(Location.search)
  }, [])

  const handleOnClick = () => {
    history.push(`/business-info/${business?.id}`)
  }

  useEffect(() => {
    if (apiUrl.includes(API.defaults.baseURL)) {
      const imageArray = business?.image?.medium_thumbnail?.split("media")
      const imageString = imageArray[0] + ".media" + imageArray[1]
      setImage(imageString)
    } else {
      setImage(business?.image?.medium_thumbnail)
    }
  }, [business])

  return !permissions.some((e) => e.codename === "view_businessinfo") ? (
    <div className="page-content">
      <div className="text-center">
        <h1>No autorizado para ver esta pagina</h1>
      </div>
    </div>
  ) : (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Alert color="danger" isOpen={businessInfo.isError}>
            {businessInfo?.error?.errors?.map((error) => error?.message)}
          </Alert>

          <h2 style={{ textAlign: "center" }}> Información general </h2>
          <div className="bg-white p-4" style={{ borderRadius: "10px" }}>
            <Row className="g-4 align-items-stretch">
              <Col lg="4" md="5">
                <div
                  style={{
                    height: "100%",
                    border: "1px solid #e9ecef",
                    borderRadius: "10px",
                    padding: "20px",
                    textAlign: "center",
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      maxWidth: "280px",
                      height: "280px",
                      margin: "0 auto",
                      borderRadius: "8px",
                      overflow: "hidden",
                      backgroundColor: "#ffffff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={`${image}?w=248&fit=crop&auto=format`}
                      srcSet={image}
                      alt="Logo de la empresa"
                      loading="lazy"
                      style={{ width: "100%", height: "100%", objectFit: "contain" }}
                    />
                  </div>
                  <h5 style={{ marginTop: "16px", marginBottom: 0, fontWeight: 700 }}>Logo de la empresa</h5>
                </div>
              </Col>

              <Col lg="8" md="7">
                <div
                  style={{
                    height: "100%",
                    border: "1px solid #e9ecef",
                    borderRadius: "10px",
                    padding: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <div
                      style={{
                        border: "1px solid #edf1f5",
                        borderRadius: "8px",
                        padding: "14px 16px",
                        marginBottom: "16px",
                        backgroundColor: "#fbfcfd",
                      }}
                    >
                      <h5 style={{ fontWeight: 700, marginBottom: "14px" }}>Información general</h5>
                      <Row>
                        <Col md="6" className="mb-3">
                          <h6 className="text-muted mb-1">Nombre</h6>
                          <h5 className="mb-0">{business?.name || "-"}</h5>
                        </Col>
                        <Col md="6" className="mb-3">
                          <h6 className="text-muted mb-1">Número telefónico</h6>
                          <h5 className="mb-0">{business?.phone_number || "-"}</h5>
                        </Col>
                        <Col md="6" className="mb-0">
                          <h6 className="text-muted mb-1">Dirección</h6>
                          <h5 className="mb-0">
                            {`${business?.street || ""} ${business?.neighborhood || ""}`.trim() || "-"}
                          </h5>
                        </Col>
                        <Col md="6" className="mb-0">
                          <h6 className="text-muted mb-1">Código postal</h6>
                          <h5 className="mb-0">{business?.zip_code || "-"}</h5>
                        </Col>
                      </Row>
                    </div>

                    <div
                      style={{
                        border: "1px solid #edf1f5",
                        borderRadius: "8px",
                        padding: "14px 16px",
                        backgroundColor: "#fbfcfd",
                      }}
                    >
                      <h5 style={{ fontWeight: 700, marginBottom: "14px" }}>Datos fiscales</h5>
                      <Row>
                        <Col md="6" className="mb-3">
                          <h6 className="text-muted mb-1">RFC</h6>
                          <h5 className="mb-0">{business?.rfc || "-"}</h5>
                        </Col>
                        <Col md="6" className="mb-3">
                          <h6 className="text-muted mb-1">Razón social</h6>
                          <h5 className="mb-0">{business?.business_name || "-"}</h5>
                        </Col>
                        <Col md="6" className="mb-3">
                          <h6 className="text-muted mb-1">Régimen fiscal</h6>
                          <h5 className="mb-0">{business?.tax_regimen_data?.name || "-"}</h5>
                        </Col>
                        <Col md="6" className="mb-3">
                          <h6 className="text-muted mb-1">Dirección fiscal</h6>
                          <h5 className="mb-0">{business?.fiscal_address || "-"}</h5>
                        </Col>
                        <Col md="6" className="mb-0">
                          <h6 className="text-muted mb-1">Código postal fiscal</h6>
                          <h5 className="mb-0">{business?.fiscal_zipcode || "-"}</h5>
                        </Col>
                      </Row>
                    </div>
                  </div>

                  {canEdit && (
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "8px" }}>
                      <Button onClick={handleOnClick} color="info" type="button">
                        <i className="fa fa-edit" /> Editar
                      </Button>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BusinessInfo
